import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Statute from '../components/Statute';
import Mission from '../components/Mission';
import HowWeHelp from '../components/HowWeHelp';
import Impact from '../components/Impact';
import Gallery from '../components/Gallery';
import WhyCollaborate from '../components/WhyCollaborate';
import Stories from '../components/Stories';
import Donate from '../components/Donate';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Statute />
      <Mission />
      <HowWeHelp />
      <Impact />
      <Gallery />
      <WhyCollaborate />
      <Stories />
      <Donate />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
